import { createModalStore } from '@/shared/lib/modal';
import { PricingEntryPoint } from '@/shared/lib/pricingAttribution';
import { RecordingCheckoutTarget } from '@/shared/lib/recordingCheckoutReturn';

export type RecordingPaywallVariant = 'autoZoom' | 'download' | 'recordingMinutes' | 'translateMinutes';

type RecordingPaywallState = {
  pricingEntryPoint?: null | PricingEntryPoint;
  // The recording and the action the paywall blocked: a purchase made from here returns to it and repeats the action,
  // a cancelled one returns to it.
  recordingCheckoutTarget?: null | RecordingCheckoutTarget;
  variant: RecordingPaywallVariant;
};

const initialState: RecordingPaywallState = {
  pricingEntryPoint: null,
  recordingCheckoutTarget: null,
  variant: 'download',
};

export const useRecordingPaywallStore = createModalStore<RecordingPaywallState>(initialState);
